package com.stevdza.san.sections

import androidx.compose.runtime.Composable
import com.stevdza.san.components.LikeCard
import com.stevdza.san.components.PortfolioTitle
import com.stevdza.san.models.Likes
import com.stevdza.san.models.Section
import com.stevdza.san.styles.LikesArrowIconStyle
import com.stevdza.san.util.Constants.SECTION_WIDTH
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun LikesSection() {
    Box(
        modifier = Modifier
            .id(Section.Likes.id)
            .maxWidth(SECTION_WIDTH.px)
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        LikesContent()
    }
}

@Composable
fun LikesContent() {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent
                else 90.percent
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        PortfolioTitle(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = 20.px),
            section = Section.Likes
        )
        LikesCards(breakpoint = breakpoint, 0)
        LikesNavigation(0)
        Row( modifier = Modifier.height(40.px)){}
        LikesCards(breakpoint = breakpoint, 1)
        LikesNavigation(1)
    }
}

@Composable
fun LikesCards(breakpoint: Breakpoint, type : Int = 0) {
    Row(
        modifier = Modifier
            .id("scrollableContainer" + type)
            .fillMaxWidth()
            .margin(40.px)
            .maxWidth(
                if (breakpoint > Breakpoint.MD) 950.px
                else if (breakpoint > Breakpoint.SM) 625.px
                else 300.px
            )
            .overflow(Overflow.Hidden)
            .scrollBehavior(ScrollBehavior.Smooth)
    ) {
        Likes.entries.filter { it.type == type }.forEach { like ->
            LikeCard(
                modifier = Modifier.margin(
                    right = if (like != Likes.Four) 25.px else 0.px
                ),
                like = like
            )
        }
    }
}

@Composable
fun LikesNavigation(type : Int = 0) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Center
    ) {
        FaArrowLeft(
            modifier = LikesArrowIconStyle.toModifier()
                .margin(right = 40.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    document.getElementById("scrollableContainer" + type)
                        ?.scrollBy(x = (-160.0), y = 0.0)
                },
            size = IconSize.LG
        )
        FaArrowRight(
            modifier = LikesArrowIconStyle.toModifier()
                .cursor(Cursor.Pointer)
                .onClick {
                    document.getElementById("scrollableContainer" + type)
                        ?.scrollBy(x = 160.0, y = 0.0)
                },
            size = IconSize.LG
        )
    }
}